<template>
    <section class="agatis-info">
      <b-container>
        <b-row>
          <b-col sm="12" md="6" lg="6">
           <router-link to="/" class="logo-link">
              <img class="icon-shelter" src="../../assets/img/agatis-logo.svg" alt="Agatis logo">
            </router-link>
          </b-col>
          <b-col sm="12" md="6" lg="6" class="text-right text-md-left text-lg-right">
            <address class="address-cotainer">
              <p class="location">{{$t('ukraine')}}, {{$t('lviv')}}</p>
              <p class="mail"><a class="mail-link" href="mailto:agatisgames@gmail.com">agatisgames@gmail.com</a></p>
            </address>
          </b-col>
        </b-row>
      </b-container>
    </section>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
  .agatis-info{
    padding-top: 130px;
    padding-bottom: 40px;
    background: linear-gradient(358deg, #755B95 75%, rgba(117, 91, 149, 0) 76%);
    .logo-link{
      display:inline-flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width: 100%;
        max-width: 190px;
        height: auto;
        filter: invert(100%) sepia(5%) saturate(0%) hue-rotate(316deg) brightness(105%) contrast(107%);
        @media screen and (min-width: 320px) {
          max-width: 114px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          max-width: 190px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
    .address-cotainer{
      display: inline-flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 0;
      gap: 8px;
    @media screen and (min-width: 320px) {
      margin-top: 40px;
      align-items: flex-end;
    }
    @media screen and (min-width: 768px) {
     margin-top: 0;
     align-items: flex-start;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
      p{
        margin: 0;
      }
      .location{
        color: #FFF;
        font-family: $main-font;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28.8px;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 19.2px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 24px;
          line-height: 28.8px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .mail-link{
        color: #FFFF9F;
        font-family: $main-font;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 28.8px;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 19.2px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 24px;
          line-height: 28.8px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
  }
</style>
